<script>
  import ColorPicker from "../../editorInterface/component/colorPicker.svelte";
  import { Input } from "sveltestrap";
  import {
    isNumericEncoding,
    isColorEncoding,
  } from "../../editor/component/mark.js";
  export let index,
    inputFocusAction,
    inputBlurAction,
    range_values,
    currentEncoding,
    afterScaleUpdate;
  let inputElem;
  let showColorPicker = false;
  let afterPickAction;
  let pickerCurrentColor;
  function openColorPicker(action, curr) {
    showColorPicker = true;
    if (action.constructor.name === "Function") afterPickAction = action;
    pickerCurrentColor = curr;
  }
  function closeColorPicker() {
    showColorPicker = false;
    afterPickAction = undefined;
    pickerCurrentColor = undefined;
  }
</script>

{#if isNumericEncoding(currentEncoding)}
  <Input
    type="number"
    name={"scale_range_" + index}
    class="custom-form-select"
    autocomplete="off"
    on:focus={inputFocusAction}
    on:blur={inputBlurAction}
    bind:value={range_values[index]}
    on:change={afterScaleUpdate}
  />
{:else if isColorEncoding(currentEncoding)}
  <button
    type="button"
    class="text-truncate custom-form-select px-2 text-sm"
    on:click={() => {
      openColorPicker((event) => {
        range_values[index] =
          "rgba(" +
          [event.detail.r, event.detail.g, event.detail.b, event.detail.a].join(
            ","
          ) +
          ")";
        afterScaleUpdate(event);
      }, range_values[index] || "rgba(0,0,0,1)");
    }}
    style={`background-color: ${range_values[index]};`}
  >
    <span style="color: white; mix-blend-mode: difference;"
      ><i class="bi bi-paint-bucket me-1" alt="pick color" />{range_values[
        index
      ]}
    </span>
  </button>
  <Input
    type="hidden"
    name={"scale_range_" + index}
    on:focus={inputFocusAction}
    on:blur={inputBlurAction}
    bind:value={range_values[index]}
    bind:this={inputElem}
    on:change={(event) => {
      showColorPicker = false;
    }}
  />
{:else}
  <Input
    type="text"
    name={"scale_range_" + index}
    class="custom-form-select"
    autocomplete="off"
    on:focus={inputFocusAction}
    on:blur={inputBlurAction}
    bind:value={range_values[index]}
    on:change={afterScaleUpdate}
  />
{/if}

<!-- color picker -->
{#if showColorPicker}
  <ColorPicker
    x="540px"
    y="300px"
    color={pickerCurrentColor}
    afterPick={afterPickAction}
    closer={closeColorPicker}
  />
{/if}
